import React from 'react';
import '../scss/components/_joinHappyCustomers.scss'

const JoinHappyCustomers = props => (
    <div className="container">
        <div className="row align-items-center">
            <div className="col-md-12 text-center join-happy-customers">
                <img src='/home/bunny.svg' alt="hop" />
                <h2 className="mb-2 mb-md-4 "> {props.title} </h2>
                <div className="d-flex flex-wrap justify-content-center customer-logos-2">
                    <img src='/home/brand_logos/bettermortgage-logo.svg' alt="bettermortgage" className="" />
                    <img src='/home/brand_logos/peloton-logo.svg' alt="peloton" className="" />                        
                    <img src='/home/brand_logos/starburst-logo_black.svg' alt="Starbust" className="" />
                    <img src='/home/brand_logos/bettercloud-logo.svg' alt="bettercloud" className="" />
                    <img src='/home/brand_logos/invision-logo.svg' alt="Invision" className="" />
                    <img src='/home/brand_logos/remy-logo.svg' alt="Remy" className="" />
                    <img src='/home/brand_logos/postman-logo-black.svg' alt="Postman" className="" />
                    <img src='/home/brand_logos/lightspeed-logo-black.svg' alt="lightspeed" className="smallSVG" width="99" />
                    <img src='/home/brand_logos/openai-logo.svg' alt="Openai"  />
                    <img src='/home/brand_logos/assurance-logo.svg' alt="Assurance" className="" />
                    <img src='/home/brand_logos/sequoia-logo.svg' alt="sequoia" className="" />
                </div>
            </div>
        </div>
    </div>
);

export default JoinHappyCustomers;